import React from 'react'

const Hero: React.FC = () => {
    return (
        <header className="container-fluid header">
            <div className="row d-flex justify-content-center">
                <div className="col-12 d-flex justify-content-around">
                    <img src="./img/HOACC.png" className="d-block img-fluid main-img" alt="House of Afros, Capes and Curls" />
                </div>
                <div className="col-12 d-flex justify-content-around">
                    <img src="./img/stpt-transparent.png" className="d-block img-fluid group-photo" alt="Steampunk themed group of HOACC members" />
                </div>
            </div>
        </header>
    )
}

export default Hero
